import React from "react";
import { motion } from "framer-motion";
import infobg from "../Assets/infobg.png";

const Info = () => {
  return (
    <section
      className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white text-center relative overflow-hidden"
      style={{
        backgroundImage: `url(${infobg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="max-w-3xl mx-auto space-y-16 relative z-10"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        {/* Tile 1 */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold">
            POWERED BY MONADSCORE
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-200">
            MonadScore powers every decision behind NTB, from liquidity sourcing
            to risk detection. It analyzes real-time market conditions,
            optimizes swap paths, and ensures every transaction delivers
            maximum performance.
          </p>
        </motion.div>

        {/* Tile 2 */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold">
            SECURITY
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-200">
            NTB integrates MonadScore’s multi-layer protection, scanning for rug
            risks, fake tokens, and malicious contracts before you trade.
            Smart token scoring, contract and liquidity validation, encrypted
            wallet backup and export.
          </p>
          <h3 className="text-lg sm:text-xl md:text-2xl">
            Trade with confidence. Protected from start to finish.
          </h3>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Info;
